import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react/dist/iconify.js";
import { api } from "../api/client";
import { useAuth } from "../auth/AuthContext";
import usePageTitle from "../utils/usePageTitle";

// Parolă forțată la primul login (flag `trebuieSchimbaParola`): utilizatorul
// nu poate accesa nicio pagină până nu schimbă parola implicită.
export default function SchimbaParolaPage() {
  usePageTitle("Schimbă parola");
  const { user, loading, refresh } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ oldPassword: "", newPassword: "", confirm: "" });
  const [salveaza, setSalveaza] = useState(false);
  const [eroare, setEroare] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.newPassword !== form.confirm) {
      setEroare("Parolele nu coincid");
      return;
    }
    setSalveaza(true);
    setEroare("");
    try {
      await api.post("/api/auth/change-password", {
        oldPassword: form.oldPassword,
        newPassword: form.newPassword,
      });
      await refresh(); // actualizează user-ul (trebuieSchimbaParola devine false)
      toast.success("Parola a fost schimbată");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setEroare(err.message);
    } finally {
      setSalveaza(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <div className="spinner-border text-primary-600" role="status">
          <span className="visually-hidden">Se încarcă…</span>
        </div>
      </div>
    );
  }
  if (!user) {
    navigate("/login", { replace: true });
    return null;
  }

  return (
    <div className="d-flex justify-content-center align-items-center p-24" style={{ minHeight: "100vh", background: "var(--neutral-50)" }}>
      <div className="card" style={{ maxWidth: 460, width: "100%" }}>
        <div className="card-body p-24">
          <div className="text-center mb-24">
            <span className="w-64-px h-64-px bg-primary-600 text-white d-inline-flex justify-content-center align-items-center rounded-circle mb-16">
              <Icon icon="solar:lock-password-outline" className="icon text-2xl" />
            </span>
            <h5 className="mb-8">Schimbă parola</h5>
            <p className="text-secondary-light mb-0">
              Din motive de securitate, trebuie să îți schimbi parola înainte de a continua.
            </p>
          </div>

          {eroare && <div className="alert alert-danger py-8">{eroare}</div>}

          <form onSubmit={submit}>
            <div className="mb-16">
              <label className="form-label fw-semibold text-secondary-light" htmlFor="parola-veche">Parola actuală *</label>
              <input id="parola-veche" type="password" className="form-control radius-8" required
                value={form.oldPassword} onChange={set("oldPassword")} autoFocus />
            </div>
            <div className="mb-16">
              <label className="form-label fw-semibold text-secondary-light" htmlFor="parola-noua">Parola nouă *</label>
              <input id="parola-noua" type="password" className="form-control radius-8" required minLength={8}
                value={form.newPassword} onChange={set("newPassword")} />
              <small className="text-secondary-light">Minim 8 caractere.</small>
            </div>
            <div className="mb-24">
              <label className="form-label fw-semibold text-secondary-light" htmlFor="parola-confirm">Confirmă parola nouă *</label>
              <input id="parola-confirm" type="password" className="form-control radius-8" required
                value={form.confirm} onChange={set("confirm")} />
            </div>
            <button type="submit" className="btn btn-primary radius-8 w-100" disabled={salveaza}>
              {salveaza ? "Se salvează…" : "Schimbă parola"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
